import type { SortOrder } from 'constants/sort';

import type { TExpectedDecisionMaker } from './edm';

export enum Status {
    NEW = 'New',
    VIEWED = 'Viewed',
    CONTACTED = 'Contacted',
    ACTIVE = 'Active',
    CLOSED = 'Closed',
    DELETED = 'Deleted',
    LISTED = 'Listed',
    SOLD = 'Sold',
    ARCHIVED = 'Archived',
    RECOMMENDED = 'Recommended',
    ALL = 'All',
}

export interface ITimelineRecord {
    created: string;
    status: Status;
    description: string | undefined;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ILead = { [k: string]: any } & {
    propertyLeadId: number;
    address: string;
    city: string;
    state: string;
    zip: string;
    edms: TExpectedDecisionMaker[];
    created: string;
    updated: string;
    estimatedMarketValue: string;
    sqFoot: number;
    owners: string[];
    bathrooms: number;
    beds: number;
    categories: string;
    timeline: ITimelineRecord[];
    leadType?: string | null;
    obitFirstName?: string | null;
    obitLastName?: string | null;
};

export interface ILeadsSortParams {
    sortBy?: string | null;
    sortOrder?: SortOrder | null;
}

export interface ILeadsWorth {
    estimatedMarketValue: string;
    count: number;
    allLeads: number;
}
